import { Box } from '@occc-app/design-system';
import { Typography } from '@occc/ui-design-system';

import type { MessageComponentProps } from './message-types.types';

import { TEXT_WRAP_SX } from '../../../../drive-insights.constants';

export const PromptMessage = ({ message }: MessageComponentProps) => (
  <Box
    sx={{
      width: 'fit-content',
      maxWidth: 480,
      bgcolor: 'drive.chipBg',
      borderRadius: '16px',
      px: 2,
      py: 1.5,
    }}
  >
    <Typography
      sx={{
        ...TEXT_WRAP_SX,
        fontSize: 15,
        lineHeight: '26px',
        color: 'drive.textPrimary',
      }}
    >
      {message.content}
    </Typography>
  </Box>
);
